/* Baresoul — AOV bundle-unlock nudge. Cart PAGE only (never the drawer) to protect the Shiprocket checkout. Also retires the stale ₹599 free-ship bar. (Claude) */
(function(){
  'use strict';
  var DISCOUNT_QTY=2;
  var SINGLE_PRICE=49900;
  if(!document.getElementById('bs-aov-style')){
    var st=document.createElement('style');
    st.id='bs-aov-style';
    st.textContent='.bs-fsbar{display:none!important;}'
      +'.bs-aov{margin:0 0 18px;padding:14px 16px;border:1px solid rgba(200,169,110,0.28);border-radius:10px;background:rgba(200,169,110,0.06);}'
      +'.bs-aov__msg{font-size:13px;letter-spacing:.02em;color:#C8A96E;font-weight:600;margin:0 0 9px;line-height:1.45;}'
      +'.bs-aov__msg b{color:#EDE5D8;font-weight:700;}'
      +'.bs-aov__track{height:7px;border-radius:6px;background:rgba(255,255,255,0.08);overflow:hidden;}'
      +'.bs-aov__fill{height:100%;width:0;border-radius:6px;background:linear-gradient(90deg,#C8A96E,#DFC08A);transition:width .5s cubic-bezier(.4,0,.2,1);}'
      +'.bs-aov__cta{display:inline-block;margin-top:11px;padding:9px 16px;background:#C8A96E;color:#0A0A0A;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;border-radius:3px;text-decoration:none;}'
      +'.bs-aov__cta:hover{background:#DFC08A;}'
      +'.bs-aov--done{background:rgba(60,160,90,0.09);border-color:rgba(80,190,120,0.4);}'
      +'.bs-aov--done .bs-aov__msg{color:#7fd99a;}'
      +'.bs-aov--done .bs-aov__fill{background:linear-gradient(90deg,#3ca05a,#7fd99a);}';
    document.head.appendChild(st);
  }
  function fmt(p){return '₹'+Math.ceil(p/100).toLocaleString('en-IN');}
  function anchors(){
    var list=[];
    var drawer=document.querySelector('cart-drawer-component, cart-drawer, [class*=cart-drawer]');
    var items=document.querySelectorAll('cart-items-component, .cart-items, #main-cart-items');
    var pageItems=null;
    items.forEach(function(el){ if(!(drawer&&drawer.contains(el))){ if(!pageItems) pageItems=el; } });
    if(pageItems){ var sec=pageItems.closest('.shopify-section')||pageItems.parentElement; if(sec) list.push(sec); }
    return list;
  }
  function render(cart){
    var qty=cart.item_count;
    var done=qty>=DISCOUNT_QTY;
    var seen=anchors();
    if(!seen.length) return;
    document.querySelectorAll('.bs-aov').forEach(function(b){ if(seen.indexOf(b.parentElement)===-1) b.remove(); });
    seen.forEach(function(a){
      var ex=a.querySelector(':scope > .bs-aov');
      if(!qty){ if(ex) ex.remove(); return; }
      var bar=ex;
      if(!bar){ bar=document.createElement('div'); a.insertBefore(bar,a.firstChild); }
      bar.className='bs-aov'+(done?' bs-aov--done':'');
      var pct=done?100:50;
      var msg=document.createElement('p'); msg.className='bs-aov__msg';
      if(done){
        msg.innerHTML='🎉 <b>20% combo unlocked!</b> Your discount auto-applies at checkout.';
      }else{
        msg.innerHTML='🎁 Add <b>1 more tee</b> → unlock <b>20% OFF both</b>. Grab a 2nd design for basically <b>'+fmt(SINGLE_PRICE*0.6)+'</b> <span style="color:#9b8f7d">(auto-applied at checkout)</span>';
      }
      var track=document.createElement('div'); track.className='bs-aov__track';
      var fill=document.createElement('div'); fill.className='bs-aov__fill'; fill.style.width=pct+'%';
      track.appendChild(fill);
      bar.innerHTML=''; bar.appendChild(msg); bar.appendChild(track);
      if(!done){
        var cta=document.createElement('a'); cta.className='bs-aov__cta'; cta.href='/collections/all'; cta.textContent='+ Add another tee';
        bar.appendChild(cta);
      }
    });
  }
  var busy=false;
  function refresh(){ if(location.pathname.indexOf('/cart')===-1) return; if(busy)return; busy=true; window.fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){busy=false;render(c);}).catch(function(){busy=false;}); }
  function upgradePDP(){
    if(location.pathname.indexOf('/products/')===-1) return;
    var note=document.getElementById('bs-combo-note'); if(!note) return;
    note.innerHTML='<span class=bs-combo-note__tag>COMBO</span>Buy <b>any 2 tees</b> → <b>20% OFF both</b>, auto-applied. That\u2019s a 2nd design for basically <b>'+fmt(SINGLE_PRICE*0.6)+'</b>. <span class=bs-combo-note__sub>Free shipping · COD available.</span>';
  }
  ['cart:refresh','cart:updated','cart:change'].forEach(function(ev){document.addEventListener(ev,function(){setTimeout(refresh,220);});});
  function start(){ refresh(); setTimeout(refresh,900); setTimeout(upgradePDP,1400); }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();
